import Vue from 'vue'
import Router from 'vue-router'

import Home from './components/home.vue'

import Client from './components/client/index.vue'

import Players from './components/client/players/index.vue'
import PlayersList from './components/client/players/list.vue'
import Player from './components/client/players/player/index.vue'
import PlayerGeneral from './components/client/players/player/general.vue'
import PlayerTransactions from './components/client/players/player/transactions.vue'
import PlayerPins from './components/client/players/player/pins.vue'
import PlayerTransBets from './components/client/players/player/trans-bets.vue'
import PlayerHdRacesBets from './components/client/players/player/hdraces-bets.vue'
import PlayerBkBets from './components/client/players/player/bk-bets.vue'

import ClientPins from './components/client/pins.vue'

import ClientBets from './components/client/bets/index.vue'
import ClientTransBets from './components/client/bets/trans-bets.vue'
import ClientHdRacesBets from './components/client/bets/hdraces-bets.vue'
import ClientBkBets from './components/client/bets/bk-bets.vue'

import Branches from './components/client/branches/index.vue'
import BranchList from './components/client/branches/list.vue'
import BranchCreate from './components/client/branches/create.vue'
import Branch from './components/client/branches/branch/index.vue'
import BranchGeneral from './components/client/branches/branch/general.vue'

import BranchPages from './components/client/branches/branch/pages/index.vue'
import BranchPagesList from './components/client/branches/branch/pages/list.vue'
import BranchPageCreate from './components/client/branches/branch/pages/create.vue'
import BranchPage from './components/client/branches/branch/pages/page.vue'

import PaymentSystem from './components/client/payment-system/index'
import WithdrawalRequests from './components/client/payment-system/withdrawal-requests'
import OperationsAwaitingAntiFraud from './components/client/payment-system/operations-awaiting-antifraud'

import ClientMessages from './components/client/messages/index.vue'

import Stats from './components/client/stats/index.vue'
import StatsProfit from './components/client/stats/profit.vue'
import StatsGames from './components/client/stats/games.vue'

import Login from './components/login.vue'

Vue.use(Router);

export function createRouter() {

  return new Router({
    // NOTE: our product could be integrated on 3thd site
    mode: 'history',

    scrollBehavior(to, from, savedPosition) {
      // NOTE: Returning the savedPosition will result in a native- like behavior when navigating with back/ forward buttons
      if (savedPosition) return savedPosition;
      else return { x: 0, y: 0 };
    },

    routes: [
      {
        path: "/",
        component: Home,
        children: [
          {
            path: "",
            name: "client",
            component: Client,
            redirect: "players",
            children: [
              {
                path: "players",
                component: Players,
                meta: { breadcrumb: { routeName: "players", lname: "players" } },
                children: [
                  {
                    path: "",
                    name: "players",
                    component: PlayersList
                  },
                  {
                    path: ":playerId",
                    component: Player,
                    meta: { breadcrumb: { routeName: "player", dynamic: "player" } },
                    children: [
                      {
                        path: "",
                        name: "player",
                        component: PlayerGeneral
                      },
                      {
                        path: "transactions",
                        name: "player-transactions",
                        component: PlayerTransactions,
                        meta: { breadcrumb: { routeName: "player-transactions", lname: "transactions" } }
                      },
                      {
                        path: "pins",
                        name: "player-pins",
                        component: PlayerPins,
                        meta: { breadcrumb: { routeName: "player-pins", lname: "pins" } }
                      },
                      {
                        path: "hdraces-bets",
                        name: "player-hdraces-bets",
                        component: PlayerHdRacesBets,
                        meta: { breadcrumb: { routeName: "player-hdraces-bets", lname: "hdraces bets" } }
                      },
                      {
                        path: "bk-bets",
                        name: "player-bk-bets",
                        component: PlayerBkBets,
                        meta: { breadcrumb: { routeName: "player-bk-bets", lname: "bk bets" } }
                      },
                      {
                        path: "redpipe-bets",
                        name: "player-redpipe-bets",
                        component: PlayerTransBets,
                        meta: { breadcrumb: { routeName: "player-redpipe-bets", lname: "redpipe bets" } },
                        props: { provider: "redpipe" }
                      },
                      {
                        path: "flg-bets",
                        name: "player-flg-bets",
                        component: PlayerTransBets,
                        meta: { breadcrumb: { routeName: "player-flg-bets", lname: "flg bets" } },
                        props: { provider: "flg" }
                      }
                    ]
                  }
                ]
              },
              {
                path: "pins",
                name: "client-pins",
                component: ClientPins,
                meta: { breadcrumb: { routeName: "client-pins", lname: "pins" } }
              },
              {
                path: "bets",
                name: "client-bets",
                component: ClientBets,
                meta: { breadcrumb: { routeName: "client-bets", lname: "bets" } },
                redirect: "/bets/redpipe",
                children: [
                  {
                    path: "redpipe",
                    name: "client-bets-redpipe",
                    meta: { breadcrumb: { routeName: "client-bets-redpipe", lname: "redpipe" } },
                    props: { provider: "redpipe" },
                    component: ClientTransBets
                  },
                  {
                    path: "flg",
                    name: "client-bets-flg",
                    meta: { breadcrumb: { routeName: "client-bets-flg", lname: "flg" } },
                    props: { provider: "flg" },
                    component: ClientTransBets
                  },
                  {
                    path: "hdraces",
                    name: "client-bets-hdraces",
                    meta: { breadcrumb: { routeName: "client-bets-hdraces", lname: "hdraces" } },
                    component: ClientHdRacesBets
                  },
                  {
                    path: "bk",
                    name: "client-bets-bk",
                    meta: { breadcrumb: { routeName: "client-bets-bk", lname: "bookmaker" } },
                    component: ClientBkBets
                  }
                ]
              },
              {
                path: "payment-system",
                name: "payment-system",
                component: PaymentSystem,
                redirect: { name: "withdrawal-requests"},
                meta: { breadcrumb: { routeName: "withdrawal-requests", lname: "payment system" } },
                children: [
                  {
                    path: "withdrawal-requests",
                    name: "withdrawal-requests",
                    component: WithdrawalRequests,
                    meta: { breadcrumb: { routeName: "withdrawal-requests", lname: "withdrawal requests" } }
                  },
                  {
                    path: "operations-awaiting-antifraud",
                    name: "operations-awaiting-antifraud",
                    component: OperationsAwaitingAntiFraud,
                    meta: { breadcrumb: { routeName: "operations-awaiting-antifraud", lname: "anti fraud" } }
                  }
                ]
              },
              {
                path: "branches",
                component: Branches,
                meta: { breadcrumb: { routeName: "branch-list", lname: "branches" } },
                children: [
                  {
                    path: "",
                    name: "branch-list",
                    component: BranchList
                  },
                  {
                    path: "new-branch",
                    name: "branch-create",
                    component: BranchCreate,
                    meta: { breadcrumb: { routeName: "branch-general", lname: "new branche" } },
                  },
                  {
                    path: ":branch",
                    component: Branch,
                    meta: { breadcrumb: { routeName: "branch-general", dynamic: "branch" } },
                    children: [
                      {
                        path: "",
                        name: "branch-general",
                        component: BranchGeneral
                      },
                      {
                        path: "pages",
                        component: BranchPages,
                        meta: { breadcrumb: { routeName: "branch-pages-list", lname: "pages" } },
                        children: [
                          {
                            path: "",
                            name: "branch-pages-list",
                            component: BranchPagesList
                          },
                          {
                            path: "new-page",
                            name: "branch-page-create",
                            component: BranchPageCreate,
                            meta: { breadcrumb: { routeName: "branch-page-create", lname: "new page" } }
                          },
                          {
                            path: ":page/:lang",
                            name: "branch-page",
                            component: BranchPage,
                            meta: { breadcrumb: { routeName: "branch-page", dynamic: "page" } }
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                path: "messages",
                name: "client-messages",
                component: ClientMessages,
                meta: { breadcrumb: { routeName: "client-messages", lname: "messages" } }
              }
            ]
          },
          {
            path: "stats",
            name: "stats",
            component: Stats,
            redirect: "stats/profit",
            meta: { breadcrumb: { routeName: "players", lname: "stats" } },
            children: [
              {
                path: "profit",
                name: "stats-profit",
                component: StatsProfit,
                meta: { breadcrumb: { routeName: "stats-profit", lname: "profit" } }
              },
              {
                path: "games",
                name: "stats-games",
                component: StatsGames,
                meta: { breadcrumb: { routeName: "stats-games", lname: "games" } }
              }
            ]
          }
        ]
      },
      {
        path: "/login",
        name: "login",
        component: Login
      },
      {
        path: '**',
        redirect: "/"
      }
    ]
  });
}




// WEBPACK FOOTER //
// ./src/router.js